import { Loader2 } from "lucide-react";

const Spinner = () => (
  <div className="flex items-center justify-center gap-2.5
                  py-[72px] px-4
                  text-[13px] text-slate-500">
    <Loader2
      size={20}
      className="animate-spin text-blue-600"
      strokeWidth={2}
    />
    Chargement des données…
  </div>
);

export default Spinner;